export function cleanPayload(payload) {
  return Object.fromEntries(
    Object.entries(payload).filter(([_, value]) => {
      if (Array.isArray(value)) {
        // Remove array if it's empty or contains only falsy values
        return value.length > 0 && value.some((v) => !!v);
      }
      return (
        value !== "" &&
        value !== null &&
        value !== undefined &&
        value !== 0 &&
        value !== false
      );
    })
  );
}
